import React from 'react'

const React_Coding_Practice_13 = () => {
  return (
    <div>
      <h1>Coding Pratice 13</h1>
    </div>
  )
}

export default React_Coding_Practice_13
